module.exports = __webpack_public_path__ + "static/media/depression_moderate.e1513185.svg";